module.exports = "/_next/static/images/d00d61154ee4b87c28a86cd2222aaa3c-phone.svg.webp";